import streamfogImage from '../imgs/mobile_title.webp';
const blogs = [
    {
      id:1,
      title: "Innovative Approach",
      dt: "January 25, 2024",
      image: "https://picsum.photos/id/54/800/450",
      category: "Product", 
      content:
        "In the ever-accelerating world of technological innovation, the convergence of Augmented Reality (AR) streaming and 3D technology is poised to redefine the way we perceive and interact with the digital realm.In the ever-accelerating world of technological innovation, the convergence of Augmented Reality (AR) streaming and 3D technology is poised to redefine the way we perceive and interact with the digital realm.In the ever-accelerating world of technological innovation, the convergence of Augmented Reality (AR) streaming and 3D technology is poised to redefine the way we perceive and interact with the digital realm.In the ever-accelerating world of technological innovation, the convergence of Augmented Reality (AR) streaming and 3D technology is poised to redefine the way we perceive and interact with the digital realm.In the ever-accelerating world of technological innovation, the convergence of Augmented Reality (AR) streaming and 3D technology is poised to redefine the way we perceive and interact with the digital realm.In the ever-accelerating world of technological innovation, the convergence of Augmented Reality (AR) streaming and 3D technology is poised to redefine the way we perceive and interact with the digital realm.In the ever-accelerating world of technological innovation, the convergence of Augmented Reality (AR) streaming and 3D technology is poised to redefine the way we perceive and interact with the digital realm.In the ever-accelerating world of technological innovation, the convergence of Augmented Reality (AR) streaming and 3D technology is poised to redefine the way we perceive and interact with the digital realm.In the ever-accelerating world of technological innovation, the convergence of Augmented Reality (AR) streaming and 3D technology is poised to redefine the way we perceive and interact with the digital realm.In the ever-accelerating world of technological innovation, the convergence of Augmented Reality (AR) streaming and 3D technology is poised to redefine the way we perceive and interact with the digital realm.In the ever-accelerating world of technological innovation, the convergence of Augmented Reality (AR) streaming and 3D technology is poised to redefine the way we perceive and interact with the digital realm.",
    },
    {
      id:2,
      title: "3D Stream",
      dt: "January 2, 2024",
      image: "https://picsum.photos/id/1/800/450",
      category: "Announcements",
      content:
        "In the ever-accelerating world of technological innovation, the convergence of Augmented Reality (AR) streaming and 3D technology is poised to redefine the way we perceive and interact with the digital realm.",
    },
    {
      id:3,
      title: "Streamfog with AR",
      dt: "December 25, 2023",
      image: "https://picsum.photos/id/103/800/450",
      category: "Guide",
      content:
        "In the ever-accelerating world of technological innovation, the convergence of Augmented Reality (AR) streaming and 3D technology is poised to redefine the way we perceive and interact with the digital realm.",
    },
    {
      id:4,
      title: "Streamfog twitch",
      dt: "January 5, 2024",
      image: "https://picsum.photos/seed/picsum/800/450",
      category: "Guide",
      content:
        "In the ever-accelerating world of technological innovation, the convergence of Augmented Reality (AR) streaming and 3D technology is poised to redefine the way we perceive and interact with the digital realm.",
    },
    {
      id:5,
      title: "Streamfog twitch",
      dt: "January 5, 2024",
      image: streamfogImage,
      category: "Guide",
      content:
        "In the ever-accelerating world of technological innovation, the convergence of Augmented Reality (AR) streaming and 3D technology is poised to redefine the way we perceive and interact with the digital realm.",
    },
    {
      id:6,
      title: "Streamfog twitch",
      dt: "January 5, 2024",
      image: streamfogImage,
      category: "Guide",
      content:
        "In the ever-accelerating world of technological innovation, the convergence of Augmented Reality (AR) streaming and 3D technology is poised to redefine the way we perceive and interact with the digital realm.",
    },
    {
      id:7,
      title: "Streamfog twitch",
      dt: "January 5, 2024",
      image: "https://picsum.photos/seed/picsum/800/450",
      category: "Guide",
      content:
        "In the ever-accelerating world of technological innovation, the convergence of Augmented Reality (AR) streaming and 3D technology is poised to redefine the way we perceive and interact with the digital realm.",
    },
    
  ];

  export default blogs;